import { Dialog } from 'primereact/dialog';
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import {  crearContactoComercio, modificarContactoComercio } from '../services/comercio.service';
import { Toast } from 'primereact/toast';
import { useGlobalContext } from "../../shared/context/global.context";
import { Dropdown } from 'primereact/dropdown';
interface ITipoContactos{
    tipoContacto:string,
    idTipo:number
}
interface IProps {
    tipoContactos:{tipoContacto:string,idTipo:number}[],
    type?: string,
    selectedUser?:any
    reloadContacts?:any
}
const defaultProps: IProps = {
    tipoContactos:[],
    selectedUser:{},
    type: "",
}

const ModalEditar = (props: IProps) => {
    const [displayBasic, setDisplayBasic] = useState(false);
    const [visible, setVisible] = useState(true)
    const {comercioSelecionado} = useGlobalContext()
    const [selectTipoContacto , setSelectTipoContacto]=useState<any>(null)
    const [contacto, setContacto] = useState(
        {
            idContacto: 0,
            email: "",
            telefono: "",
            nombre: "",
            apellido: "",
            idTipo: 0
        }
    );
    const toast = useRef<any>(null)

    useEffect(() => {
        console.log(props)
        if (props.type == 'modify') {
            let tipo=props.tipoContactos.find(x=>x.idTipo==props.selectedUser.idTipo)
            setSelectTipoContacto(tipo)
            setContacto({
                idContacto: props.selectedUser.id,
                idTipo: props.selectedUser.idTipo ? props.selectedUser.idTipo : 0,
                email: props.selectedUser.email!,
                telefono: props.selectedUser.telefono!,
                nombre: props.selectedUser.nombre!,
                apellido: props.selectedUser.apellido!
            })
        }
    }, [])

    const dialogFuncMap = {
        'displayBasic': setDisplayBasic,
    }
    const onHide = (name: string) => {
        dialogFuncMap[`displayBasic`](false);
        setVisible(!visible)
    }
 
const onTipoContactoChange=(e:any)=>{
    setSelectTipoContacto(e.value)
    setContacto(contacto => ({ ...contacto, idTipo: e.value.idTipo}))
    }
 
    const Action = async () => {
        if (props.type == "modify") {
            const {data,status} = await modificarContactoComercio(comercioSelecionado[0].comercioId, props.selectedUser.id, contacto)
            if (status === 200) {
                if (toast.current !== null) {
                    toast.current.show({ severity: 'success', summary: 'Operacion exitosa', detail: 'Contacto modificado ', life: 3000 })
                    props.reloadContacts()
                    setVisible(false)
                }
            }
        } else {
            const {data,status} = await crearContactoComercio(comercioSelecionado[0].comercioId, contacto)
            if (status === 200) {
                if (toast.current !== null) {
                    toast.current.show({ severity: 'success', summary: 'Operacion exitosa', detail: 'Contacto Creado ', life: 3000 })
                    props.reloadContacts()
                    setVisible(false)
                }
            }
        }
    }
    const renderFooter = (name: string) => {
        return (
            <div>
                <Button label="Cancelar" icon="pi pi-times" onClick={() => onHide('displayBasic')} className="p-button-text" />
                <Button label={props.type == 'modify'?'Guardar':'Crear'} icon="pi pi-check" onClick={() => Action()} autoFocus />
            </div>
        );
    }
    return (
        
        <div>
             <Toast ref={toast} position="bottom-right" />
            <Dialog header="Datos de Contacto" visible={visible}
                onHide={() => onHide('displayResponsive')}
                breakpoints={{ '960px': '75vw' }} style={{ width: '50vw' }}
                footer={renderFooter('displayResponsive')}>
                <div className="flex align-items-center justify-content-center">
                <div className="p-grid p-fluid  p-align-baseline align-items-center justify-content-center">
                    <div className="p-col-5">
                        <label htmlFor="name" className="block" style={{ marginRight: '1rem', marginLeft: '1rem' }}>Nombre :</label>
                        <InputText id='name' placeholder={props.selectedUser? props.selectedUser.nombre : ''}
                            value={contacto.nombre} onChange={(e: any) => setContacto(contacto => ({ ...contacto, nombre: e.target.value }))}
                            className="p-inputtext-lg  text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
                        />
                    </div>
                    <div className="p-col-5" >
                        <label htmlFor="lastName" className="block  " style={{ marginRight: '1rem', marginLeft: '1rem' }}>Apellido :</label>
                        <InputText id='LastName' placeholder={props.selectedUser ? props.selectedUser.apellido : ''} value={contacto.apellido}
                            onChange={(e: any) => setContacto(contacto => ({ ...contacto, apellido: e.target.value }))}
                            className="p-inputtext-lg  text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
                        />
                    </div>
                    <div className="p-col-10">
                        <label htmlFor="email" className="block " style={{ marginRight: '1rem', marginLeft: '1rem' }}>Email :</label>
                        <InputText id='email' placeholder={props.selectedUser  ? props.selectedUser.email : ''} value={contacto.email}
                            onChange={(e: any) => setContacto(contacto => ({ ...contacto, email: e.target.value }))}
                            className=" p-inputtext-lg  text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
                        />
                    </div>
                    <div className="p-col-5 " style={{paddingBottom:'2rem'}}>
                        <label htmlFor="phone" className="block " style={{ marginRight: '1rem', marginLeft: '1rem' }}>Teléfono :</label>
                        <InputText id='phone' placeholder={props.selectedUser ? props.selectedUser.telefono : ''} value={contacto.telefono}
                            className="p-inputtext-lg  text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
                            onChange={(e: any) => setContacto(contacto => ({ ...contacto, telefono: e.target.value }))}
                        />
                        </div>
                        <div className="p-col-5 " style={{paddingBottom:'2rem'}}>
                            <label htmlFor="contactTipe" className="block " style={{ marginRight: '1rem', marginLeft: '1rem' }}>Tipo Contacto :</label>
                            <Dropdown value={props.selectedUser? selectTipoContacto : selectTipoContacto} options={props.tipoContactos} onChange={(e: any) => onTipoContactoChange(e)} optionLabel="tipoContacto" placeholder="tipos de contactos" />
                        </div>
                     
                </div>
                </div>
            </Dialog>
        </div>
    );
};
export default ModalEditar;